import { createActions, createReducer } from 'reduxsauce';
import update from 'immutability-helper';
import type { WarehouseBuilding } from 'contracts/WarehouseBuildings';

const { Types, Creators } = createActions(
  {
    request: ['warehouseId', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    reset: [],
  },
  { prefix: 'LIST_WAREHOUSE_BUILDINGS_' }
);

export interface ListWarehouseBuildingsRequestAction {
  warehouseId: number | string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface State {
  data: WarehouseBuilding[];
  loading: boolean;
  errorMessage: string | null;
}

const INITIAL_STATE: State = { data: [], loading: false, errorMessage: null };

export const listWarehouseBuildings = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: (state: State) =>
    update(state, {
      loading: { $set: true },
      errorMessage: { $set: null },
    }),
  [Types.SUCCESS]: (state: State, action: { data: WarehouseBuilding[] }) =>
    update(state, {
      data: { $set: action.data },
      loading: { $set: false },
    }),
  [Types.FAILURE]: (state: State, action: { errorMessage: string }) =>
    update(state, {
      loading: { $set: false },
      errorMessage: { $set: action.errorMessage },
    }),
  [Types.RESET]: () => INITIAL_STATE,
});

export const ListWarehouseBuildingsTypes = Types;
export const ListWarehouseBuildingsActions = Creators;
